var React = require('react');

function IcEditComponent (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"ic-edit"},React.createElement("path",{"id":"Subtract","fillRule":"evenodd","clipRule":"evenodd","d":"M13.8567 7.68437L13.0726 6.92737L12.3156 6.14332L3.91667 14.5423V16.0833H5.45772L13.8567 7.68437ZM15.9217 5.24495L14.7551 4.07828L14.5783 4.25505L15.7449 5.42172L15.9217 5.24495ZM16.8441 6.34406L5.93811 17.25H2.75V14.062L13.6727 3.15999C13.8176 3.0279 13.9758 2.92713 14.1477 2.856C14.3181 2.78546 14.4974 2.75 14.6875 2.75C14.8776 2.75 15.0614 2.78548 15.2405 2.85712C15.4137 2.92641 15.563 3.0298 15.6906 3.16903L16.8471 4.34652L16.8519 4.35096C16.9897 4.47725 17.0883 4.62433 17.1507 4.7944C17.2176 4.97697 17.25 5.15623 17.25 5.33333C17.25 5.52624 17.217 5.70792 17.1517 5.88009C17.089 6.04539 16.9881 6.20002 16.8441 6.34406Z","fill":"white"})));
}

IcEditComponent.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = IcEditComponent;

IcEditComponent.default = IcEditComponent;



//////////////////
// WEBPACK FOOTER
// ./src/components/MyTarifMobileSectionV2/images/ic-edit.component.svg
// module id = 1626
// module chunks = 0